<template>
  <div style="width:100%; height:100%">
    컴포넌트 팝업 입니다.
  </div>
</template>
<script>
  export default {}
</script>
<style scoped>
</style>
